import React from "react";

const FAQ = ({ data }) => {
  return (
    <div className="w-full max-w-3xl mx-auto p-4">
    <h2 className="text-center text-2xl">Frequently Asked Questions (FAQ)</h2>

      {data.map((item, index) => (
        <div
          key={index}
          className="mb-4 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition"
        >
          <h3 className="bg-green-50 p-3 rounded-t-lg font-semibold text-gray-800">
            {item.question}
          </h3>
          <p className="p-3 text-gray-600">
            {item.answer}
          </p>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
